// extracted by mini-css-extract-plugin
var _1 = "icon__a_mMl";
var _2 = "signs-overlay-button__v2YS1";
export { _1 as "icon", _2 as "signs-overlay-button" }
